import styled from 'styled-components';

export const THeadRow = styled.tr`
  height: 42px;
`;
